import React from 'react';
import { Loader2, ThumbsUp } from 'lucide-react';

const ObjectifFinalizeButton = ({ 
  onClick, 
  isLoading, 
  isDisabled = false 
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isLoading || isDisabled}
      className={`
        flex-1 p-4 rounded-lg flex items-center justify-center 
        transition-all duration-300 ease-in-out
        ${isDisabled || isLoading 
          ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
          : 'bg-gradient-to-r from-purple-500 to-indigo-600 text-white hover:from-purple-600 hover:to-indigo-700'
        }
      `}
    >
      {isLoading ? (
        <div className="flex items-center">
          <Loader2 className="h-5 w-5 mr-2 animate-spin" />
          <span>Finalisation en cours...</span>
        </div>
      ) : (
        <>
          <ThumbsUp className="h-5 w-5 mr-2" />
          <span>Finaliser l'objectif</span>
        </>
      )}
    </button>
  );
};

export default ObjectifFinalizeButton;